import jwtDecode from 'jwt-decode';
import axios from 'axios';
import Swal from "sweetalert2";

// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.baseURL = 'https://dasi.do:5583/api' //'https://dasi.do:5581/api' //config.API_URL;
//axios.defaults.baseURL = 'https://localhost:7086/api' //'https://dasi.do:5581/api' //config.API_URL;

// intercepting to capture errors
axios.interceptors.response.use(
    (response) => {
        if(response.status ===201 || response.status ===204){
            Swal.fire({
                title: 'Correcto!',
                html: 'Datos registrados correctamente!',
                icon: 'success',
            }); 
        }
        return response;
    },
    (error) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        let message;
const response =error?.response?.data;
        if (error && error.response && error.response.status === 404) {
            // window.location.href = '/not-found';
        } else if (error && error.response && error.response.status === 403) {
            window.location.href = '/access-denied';
        } else {
            switch (error.response.status) {
                case 401:
                    message = 'Usuario o Contraseña Inválida';
                    break;
                case 403:
                    message = 'Access Forbidden';
                    break;
                case 404:
                    message = 'Sorry! the data you are looking for could not be found';
                    break;
                case 400:
                    Swal.fire({title: 'Verificar validación!', html: response.title, icon: 'error',});
                    break;
                default: {
                    message = error.response && error.response.data ? error.response.data['message'] : error.message || error;
                }
            }
            return Promise.reject(message);
        }
    }
);

const AUTH_SESSION_KEY = 'user_company';
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string | null) => {
    if (token) axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    else delete axios.defaults.headers.common['Authorization'];
};

const getUserFromCookie = () => {
    const user = sessionStorage.getItem(AUTH_SESSION_KEY);
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

class APICore {
    /**
     * Fetches data from given url
     */
    get = (url: string, params: any) => {
        let response;
        if (params) {
            var queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
            response = axios.get(`${url}?${queryString}`, params);
        } else {
            response = axios.get(`${url}`, params);
        }
        return response;
    };

    getA = (url: string, params: any) => {
        let response;
        if (params) {
          // Construir la cadena de consulta a partir de los parámetros
          const queryString = Object.keys(params)
            .map((key) => `${key}=${params[key]}`)
            .join('&');
      
          // Agregar la cadena de consulta al URL
          response = axios.get(`${url}?${queryString}`);
        } else {
          response = axios.get(url);
        }
        return response;
      };

      getB = (url: string, params: any, token: string | null = null) => {
        let response;
    
        // Configurar las opciones de CORS
        const corsConfig = {
            headers: {
                'Access-Control-Allow-Origin': '*', // Origen permitido
                // Otras opciones de configuración de CORS si es necesario
            }
        };
    
        // Agregar el token de autenticación si está presente
        if (token) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        }
    
        if (params) {
            // Construir la cadena de consulta a partir de los parámetros
            const queryString = Object.keys(params)
                .map((key) => `${key}=${params[key]}`)
                .join('&');
    
            // Agregar la cadena de consulta al URL y aplicar las opciones de CORS
            response = axios.get(`${url}?${queryString}`, { responseType: 'blob' });
        } else {
            // Realizar la solicitud GET y aplicar las opciones de CORS
            response = axios.get(url, { responseType: 'blob' });
        }
    
        return response;
    };

    getFile = (url: string, params: any) => {
        let response;
        if (params) {
            var queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
            response = axios.get(`${url}?${queryString}`, { responseType: 'blob' });
        } else {
            response = axios.get(`${url}`, { responseType: 'blob' });
        }
        return response;
    };

    getMultiple = (urls: string, params: any) => {
        const reqs = [];
        let queryString = '';
        if (params) {
            queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
        }

        for (const url of urls) {
            reqs.push(axios.get(`${url}?${queryString}`));
        }
        return axios.all(reqs);
    };
    /**
     * post given data to url
     */
    create = (url: string, data: any) => {
        return axios.post(url, data);
    };
    /**
     * Updates patch data
     */
    updatePatch = (url: string, data: any) => {
        return axios.patch(url, data);
    };
    /**
     * Updates data
     */
    update = (url: string, data: any) => {
        return axios.put(url, data);
    };

    updateData = (url: string) => {
        return axios.put(url);
    };
    /**
     * Deletes data
     */
    delete = (url: string) => {
        return axios.delete(url);
    };
    /**
     * post given data to url with file
     */
    createWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.post(url, formData, config);
    };

    saveFileWithFormData = <arg>(url: string, formData: any) => {    
        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.post(url, formData, config);
    };
    /**
     * post given data to url with file
     */
    updateWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.patch(url, formData, config);
    };

    updateFileWithFormData = (url: string, formData: any) => {
        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.put(url, formData, config);
    };

    isUserAuthenticated = () => {
        const user = this.getLoggedInUser();

        if (!user) {
            return false;
        }
        const decoded: any = jwtDecode(user.token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
            console.warn('access token expired');
            return false;
        } else {
            return true;
        }
    };

    setLoggedInUser = (session: any) => {
        if (session) sessionStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
        else {
            sessionStorage.removeItem(AUTH_SESSION_KEY);
        }
    };
    /**
     * Returns the logged in user
     */
    getLoggedInUser = () => {
        return getUserFromCookie();
    };

    setUserInSession = (modifiedUser: any) => {
        let userInfo = sessionStorage.getItem(AUTH_SESSION_KEY);
        if (userInfo) {
            const { token, user } = JSON.parse(userInfo);
            this.setLoggedInUser({ token, ...user, ...modifiedUser });
        }
    };
}

/*
Check if token available in session
*/
let user = getUserFromCookie();
if (user) {
    const { token } = user;
    if (token) {
        setAuthorization(token);
    }
}

export { APICore, setAuthorization };